import React from 'react';
import { Link } from 'react-router-dom';

import generalHelpers from '../../services/generalHelpers';

const SHOP_PATH = '/shop/all';

const money = (amount) => `$${Number(amount).toFixed(2)}`;

/* Shown above the cart in the drawer and above the order summary at checkout,
   so it lives here rather than in the checkout container: this stylesheet is in
   the bundle on every route, the container's only loads on /checkout.

   It draws nothing unless there is a gap to name. cartTotals zeroes the gap the
   moment the order has free shipping by any of its four routes, so a subscriber
   — who has the rate whatever the cart costs — is never told they are short of
   it. Rounding is the other reason for the guard: a gap of a few cents formats
   as $0.00, and "you're only $0.00 away" is not a sentence. */
const FreeShippingNudge = ({ gap, onNavigate }) => {
  if (!(gap >= 0.01)) return null;

  return (
    <p className='coProto-shipNudge'>
      You&apos;re only <strong>{money(gap)}</strong> away from free shipping!{' '}
      <Link
        to={generalHelpers.appendStoredUTMs(SHOP_PATH)}
        onClick={onNavigate}
      >
        Keep shopping
      </Link>
    </p>
  );
};

export default FreeShippingNudge;
